import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Globe } from 'lucide-react';
import './Banktype.css';

const url = process.env.REACT_APP_BACKEND_URL;

const EditBanktype = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState({
    name: "",
    number: ""
  });

  useEffect(() => {
    const fetchBanktype = async () => {
      try {
        const response = await axios.get(`${url}/api/bank/${id}`);
        setData({
          name: response.data.data.name,
          number: response.data.data.number
        });
      } catch (error) {
        toast.error("Failed to load Bank Type data");
        navigate('/ViewBanktype');
      }
    };

    fetchBanktype();
  }, [id, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const response = await axios.put(`${url}/api/bank/${id}`, {
        name: data.name,
        number: data.number
      });

      if (response.data.success) {
        toast.success("Bank Type updated successfully!");
        navigate('/ViewBanktype');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update Bank Type");
    } finally {
      setSubmitting(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="form-wrapper">
      <div className="country-form-container">
        <h2 className="form-title">
          <Globe size={20} className="inline mr-2" /> Edit Bank Type
        </h2>
        
        <form className="country-form" onSubmit={handleSubmit}>
          {/* Bank Type Name */}
          <div className="form-field filled">
            <input
              type="text"
              name="name"
              value={data.name}
              onChange={handleChange}
              required
            />
            <label>Bank Type</label>
          </div>

          {/* Bank Number */}
          <div className="form-field filled">
            <input
              type="text"
              name="number"
              value={data.number}
              onChange={handleChange}
              required
            />
            <label>Bank/Wallet Number</label>
          </div>

          <div className="button-group">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => navigate('/ViewBanktype')}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="submit-btn" 
              disabled={submitting}
            >
              {submitting ? "Updating..." : "Update Bank Type"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditBanktype;
